import * as Yup from 'yup';
import estadisticasDiarioFormModel from './estadisticasDiarioFormModel';

const {
    formField: {
        nombre_cliente,
        startDate,
        endDate
    }
} = estadisticasDiarioFormModel;

export default [
    Yup.object().shape({
        [nombre_cliente.name]: Yup.object().shape({
            value: Yup.string().required(nombre_cliente.requiredErrorMsg),
            label: Yup.string().required(nombre_cliente.requiredErrorMsg)
        }).nullable(),
        [startDate.name]: Yup.string().nullable(),
        [endDate.name]: Yup.string().nullable()
    })
];
